import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=78b41cae&scoped=true&"
import script from "./MediaPreview.vue?vue&type=script&lang=ts&"
export * from "./MediaPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=78b41cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b41cae",
  null
  
)

export default component.exports